

































































































































































































































































































import { Component } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import DetailsEditDialog from '@/components/Accounts/DepositAccounts/Details/DetailsEditDialog.vue';
import AccountState from '@/components/Accounts/Shared/AccountState.vue';
import AccountStateEditDialog from '@/components/Accounts/DepositAccounts/Details/AccountStateEditDialog.vue';
import ProductDetailsEditDialog from '@/components/Accounts/DepositAccounts/Details/ProductDetailsEditDialog.vue';
import ProductMigrationState from '@/components/Products/ProductMigrations/ProductMigrationState.vue';
import AccountTimeline from '@/components/Accounts/DepositAccounts/Details/AccountTimeline.vue';
import PermissionUtils from '@/lib/permissionUtils';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';

@Component({ name: 'Details', components: { DetailsEditDialog, AccountState, AccountStateEditDialog, ProductDetailsEditDialog, ProductMigrationState, AccountTimeline } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;

    get account() {
        return DepositAccountModule.depositAccount;
    }

    get iban() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].iban;
        }
        return "";
    }

    get bic() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].bic;
        }
        return "";
    }

    get sortCode() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].sortCode;
        }
        return "";
    }

    get accountNumber() {
        // PaymentInterfaces can be undefined or an empty array
        if (this.account.paymentInterfaces?.length > 0) {
            return this.account.paymentInterfaces[0].accountNumber;
        }
        return "";
    }

    get productIssue() {
        return DepositAccountSettingsModule.productIssue;
    }

    get defaultWallet() {
        return DepositAccountModule.depositAccount.wallets.find(wallet => wallet.default);
    }

    get includesUKPayeeType() {
        // Whether or not to show certain account details based on the payee type
        return this.availablePayeeTypes.includes(PayeeType.UK);
    }

    get availablePayeeTypes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePayeeTypes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePayeeTypes"
        return AuthModule.me.institution.config.availablePayeeTypes;
    }

}
